import React, { useState, useEffect, createContext } from "react";

export const DarkModeContext = createContext({ isDarkModeOn: false });

export const DarkModeContextProvider = ({ children }) => {
	const [isDarkModeOn, setIsDarkModeOn] = useState(getInitialMode());

	useEffect(() => {
		localStorage.setItem("dark", JSON.stringify(isDarkModeOn));
	}, [isDarkModeOn]);

	function getInitialMode() {
		const isReturningUser = "dark" in localStorage;
		const savedMode = JSON.parse(localStorage.getItem("dark"));
		const userPrefersDark = getPrefColorScheme();
		// if the mode was saved => dark / light
		if (isReturningUser) {
			return savedMode;
			// if prefered color scheme is dark => dark
		} else if (userPrefersDark) {
			return true;
			// otherwise, light
		} else {
			return false;
		}
	}

	function getPrefColorScheme() {
		if (!window.matchMedia) return;
		return window.matchMedia("(prefers-color-scheme: dark)").matches;
	}

	const toggleDarkMode = () => setIsDarkModeOn((prevMode) => !prevMode);

	return (
		<DarkModeContext.Provider value={{ isDarkModeOn, toggleDarkMode }}>
			{children}
		</DarkModeContext.Provider>
	);
};
